import {
    AbstractStore,
    StorePartialTrace,
    TraceStoreItem
} from "./AbstractStore";
import { LatestTrace } from "../types";

interface Message {
    cmd: string;
    key: string;
    data: string;
}

export const CMD_TRACE_REQ = "1";
export const CMD_TRACE_RSP = "2";

const MESSAGE_TIMEOUT = 200;

export class IframeStore extends AbstractStore {
    private latestTrace: {
        [K: string]: TraceStoreItem;
    };

    private waitPromise: Promise<string>;

    private waitResolver: (value: string) => void;

    private waitTimer: number;

    constructor() {
        super();

        this.latestTrace = {};

        window.addEventListener(
            "message",
            this.onReceiveMessage.bind(this),
            false
        );
    }

    removeListener(): void {
        window.removeEventListener("message", this.onReceiveMessage.bind(this));
    }

    static isTopWindow(): boolean {
        return window === window.top;
    }

    private async onReceiveMessage(evt: MessageEvent): Promise<void> {
        const { data, origin, source } = evt;

        // 只允许*.qq.com之间交互
        if (origin.endsWith(".qq.com") === false) {
            return;
        }

        const { cmd, key, data: msgData } = data as Message;

        // 请求获取trace信息
        if (cmd === CMD_TRACE_REQ) {
            (source as WindowProxy).postMessage(
                {
                    cmd: CMD_TRACE_RSP,
                    key,
                    data: JSON.stringify(this.latestTrace[key])
                },
                origin
            );
            // 收到来自父页面的trace信息
        } else if (cmd === CMD_TRACE_RSP) {
            this.waitResolver(msgData);
            window.clearTimeout(this.waitTimer);
        }
    }

    async getItem(key: string): Promise<StorePartialTrace> {
        if (IframeStore.isTopWindow()) {
            throw new Error("not in iframe mode");
        }

        this.waitPromise = new Promise((resolve, reject) => {
            this.waitResolver = resolve;

            this.waitTimer = window.setTimeout(() => {
                reject(
                    new Error(
                        `wait message response timeout ${MESSAGE_TIMEOUT}ms`
                    )
                );
            }, MESSAGE_TIMEOUT);
        });

        window.top.postMessage(
            {
                cmd: CMD_TRACE_REQ,
                key
            },
            new URL(document.referrer).origin
        );

        const store = await this.waitPromise;

        this.removeItem(key);

        return this.parseStore(store);
    }

    async setItem(key: string, data: LatestTrace): Promise<number> {
        this.latestTrace[key] = this.trace2Item(data);

        return 0;
    }

    async removeItem(key: string): Promise<number> {
        this.latestTrace[key] = null;

        return 0;
    }
}
